import * as React from 'react';

import { useTheme } from '@wegroup/design-system';

interface Props {
  boxSize?: number;
}

const IllustrationEmptyState: React.FC<React.PropsWithChildren<Props>> = ({
  boxSize = 50,
  ...props
}) => {
  const { colors } = useTheme();
  return (
    <svg
      fill="none"
      width={boxSize}
      height={boxSize}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 57 56"
      {...props}
    >
      <rect
        x={4.5}
        y={4}
        width={48}
        height={48}
        rx={24}
        fill={colors.primary[100]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.54 20.8a6.24 6.24 0 1 0 0 12.48 6.24 6.24 0 0 0 0-12.48Zm-9.12 6.24a9.12 9.12 0 1 1 18.24 0 9.12 9.12 0 0 1-18.24 0Z"
        fill={colors.primary[500]}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.946 31.445a1.44 1.44 0 0 1 2.036 0l4.176 4.176a1.44 1.44 0 0 1-2.036 2.037l-4.176-4.176a1.44 1.44 0 0 1 0-2.037Z"
        fill={colors.primary[500]}
      />
      <rect
        x={4.5}
        y={4}
        width={48}
        height={48}
        rx={24}
        stroke={colors.primary[50]}
        strokeWidth={8}
      />
    </svg>
  );
};

export default IllustrationEmptyState;
